import type { CaseStudySection } from './amexCaseStudy';
export const rsiIntro = {
  client: 'RSI',
  title: 'Modernizing core platform architecture to improve profitability by 46%',
  summary: 'Redesigned the core architecture of a patient communications platform supporting 2,000+ providers, cutting support volume and shortening time-to-value.',
  background: 'linear-gradient(180deg, #F4E6E4 0%, #D7C5C1 100%)'
};
export const rsiMetrics = [{
  value: '54→79%',
  label: 'gross profit margin'
}, {
  value: '22→28%',
  label: 'conversion'
}, {
  value: '$1.5M',
  label: 'contract value'
}];
export const rsiSections: CaseStudySection[] = [{
  label: 'Problem',
  heading: 'A product that was expensive to sell and support',
  paragraphs: ['RSI is a CRM for medical practices, serving more than 2,000 providers. It was hard to learn, hard to navigate, and hard to set up. Onboarding could take 12 weeks, and admins had to call support for simple tasks. The dated UI also made the product look more complicated than it was, which hurt sales. A better UX would cut support and onboarding costs and make the product easier to sell.']
}, {
  label: 'Challenge',
  heading: 'What I was working with',
  paragraphs: ['The platform had more than 150 screens, built by a series of developers over many years. It also sat on top of a complex, idiosyncratic EHR data structure. Nobody could say which data was fixed by the EHR and which the platform could configure.']
}, {
  label: 'Key Decisions',
  bullets: ["I put daily-use features front and center. People doing the work all day shouldn't have to jump between screens to finish a task.", 'I grouped all admin functions in one place, so admins no longer had to hunt for settings across the app.', 'I standardized how client data is managed. It had been scattered across many screens, and making the EHR/platform boundary clear was key to faster onboarding.']
}, {
  label: 'Approach',
  heading: 'Rolling it out in phases',
  paragraphs: ['I introduced a rail navigation to separate the major sections of the product, then redesigned one section at a time so the work could ship sooner. I started from Material Design because it works well with Angular, which kept engineering costs down.']
}, {
  label: 'Results',
  heading: 'Prototype and results',
  paragraphs: ["I built a full prototype of the product in Figma and tested it with users before launch. Later I rebuilt it in Magic Patterns. Profit margin rose from 54% to 79%, driven by lower support and onboarding costs. One major client's lead-to-scheduled conversion went from 22% to 28%. The product also became credible for larger accounts, up to $1.5M per year per contract."]
}];